import { useAuth } from "../contexts/AuthContext"; // adjust path to your AuthContext file

// Authority -> base URL, in priority order: ADMIN > ACCOUNTANT > HR
const ROLE_PRIORITY = [
  {
    authority: "ROLE_ADMIN",
    baseUrl: () => process.env.REACT_APP_API_BASE_URL,
  },
  {
    authority: "ROLE_ACCOUNTANT",
    baseUrl: () => process.env.REACT_APP_API_ACCOUNTANT_URL,
  },
  { authority: "ROLE_HR", baseUrl: () => process.env.REACT_APP_API_HR_URL },
];

// Pure helper (usable outside components if you have the authorities array)
export const resolvePayrollBaseUrl = (authorities = []) => {
  const match = ROLE_PRIORITY.find((p) => authorities.includes(p.authority));
  // Fallback keeps previous behaviour if none of the three roles is present
  return match ? match.baseUrl() : process.env.REACT_APP_API_ACCOUNTANT_URL;
};

// Hook: call at the top of a component
export const usePayrollBaseUrl = () => {
  const { getUserAuthorities } = useAuth();
  return resolvePayrollBaseUrl(getUserAuthorities());
};
